module.exports = __webpack_public_path__ + "media/mr-game-and-watch.85ecb086.wav";